import React, { useState } from "react";
import InputFields from "../../common/input";
import { Phone, Mail, User, ArrowNext } from "../../common/icons";
import { Progress } from "flowbite-react";

import Background from "../../assets/images/accor-plus-logo.png";

function Register({}) {
  const [input, setInput] = useState({});
  const [progress, setProgress] = useState(20); // Progressbar State

  const loginFields = [
    {
      name: "first_name",
      type: "text",
      placeholder: "First Name*",
      icon: User,
      required: true,
      value: input.value,
    },
    {
      name: "email",
      type: "email",
      placeholder: "Email*",
      icon: Mail,
      required: true,
      value: input.value,
    },
    {
      name: "phone",
      type: "text",
      placeholder: "+ 61 4010003010298",
      icon: Phone,
      required: true,
      value: input.value,
    },
  ];

  function onSubmit(e) {
    e.preventDefault();

    console.error("register");
  }

  function inputChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    setInput((prevState) => ({ ...prevState, [name]: value }));
  }

  return (
    <main className="register">
      <div className="holder-register flex justify-evenly flex-col align-center mx-10">
        <div className="progress-bar">
          <Progress className="progressbar" progress={progress} />
        </div>
        <div className="holder-logo flex justify-center items-center">
          <a href="">
            <img
              src={Background}
              className="d-inline-block align-top header-logo"
              alt="Accorplus Logo"
            />
          </a>
        </div>
        <div className="holder-text text-center">
          <p className="title text-xl tracking-tight text-gray-900 dark:text-white font-montserrat font-regular">
            Welcome
          </p>
          <p className="desc text-gray font-montserrat">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna
            rhoncus a quis quis.
          </p>
        </div>
        <div className="holder-form">
          <form className="form w-full px-10 flex flex-col" onSubmit={onSubmit}>
            <InputFields inputFields={loginFields} inputChange={inputChange} />

            <div className="holder-button flex items-center mt-5">
              <button
                type="submit"
                disabled={false}
                className="btn btn-blue inline-block m-auto px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out"
              >
                {
                  <span>
                    Submit <ArrowNext className="icon-next" />
                  </span>
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Register;
